import { z } from "zod";

export const getHomeChargingEligibleVehiclesRequest = z.object({
  companyUuid: z.uuid(),
});

export type GetHomeChargingEligibleVehiclesRequest = z.infer<
  typeof getHomeChargingEligibleVehiclesRequest
>;
